import React, { useState, useEffect, useRef  } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Messages } from 'primereact/messages';
import { Card } from 'primereact/card';
import Container from 'react-bootstrap/Container';
import { useAuth } from '../contexts/AuthContext';
import { Toolbar } from 'primereact/toolbar';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

import '../config.js'

const ReceptionCodes = () => {
  // Load the status page script
  useStatusPageScript();
  
    const { locid } = useParams();
    const [receptionCodes, setReceptionCodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);
    const navigate = useNavigate();
    const msgs = useRef(null);
    const toastBC = useRef(null);
    const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
        deniedTitle: 'Reception Codes Access Denied',
        deniedMessage: 'You do not have permission to view or create reception codes for this location.',
    });


useEffect(() => {
    const fetchReceptionCodes = async () => {
        await getReceptionCodes();
      };
  
      fetchReceptionCodes();
}, [locid]);

const getReceptionCodes = async () => {
    clearAccessIssue();
    setLoading(true);
    const token = localStorage.getItem('token');
    let header = {
        headers: {
        Authorization: `Bearer ${token}`,
        },
    }

    axios.get(`${global.config.url}/locations/receptioncode/${locid}`, header)
        .then(response => {
            setReceptionCodes(response.data);
            setLoading(false);
        })
        .catch(async error => {
            if (handleAccessError(error)) {
                setLoading(false);
                return;
            }
            setError(error.message);
            setLoading(false);
        })
}

const handleAdd = () => {
  
    setLoading(true);
    const token = localStorage.getItem('token');
    let header = {
        headers: {
        Authorization: `Bearer ${token}`,
        },
    }

    axios.get(`${global.config.url}/locations/newreceptioncode/${locid}`, header)
        .then(response => {
            msgs.current.show({severity: 'success', summary: '', detail: 'Reception code is' 
            + response.data.receptionCode + ' successfully added.'});
            getReceptionCodes();
            setLoading(false);
            })
        .catch(async error => {
            if (handleAccessError(error, { deniedMessage: 'You do not have permission to create reception codes for this location.' })) {
                setLoading(false);
                return;
            }
            setError(error.message);
            setLoading(false);
        })
}

if (accessIssue) {
    return <AccessState {...accessIssue} />;
}

const endContent = (
    <React.Fragment>
        <span className="p-input-icon-left mr-3 mt-1">
            {/* <i className="pi pi-search" /> */}
            {/* <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." /> */}
            <Button icon="pi pi-refresh" className="p-button-text" onClick={() => getReceptionCodes()} disabled={loading} tooltip="Refresh reception codes" tooltipOptions={{position: "bottom"}}/>
            {/* <Button icon="pi pi-trash" className="p-button-danger mx-3" rounded loading={deleteLoading} disabled={loading} onClick={() => confirm(false)} tooltip="Delete selected hub and relays" tooltipOptions={{position: "bottom"}} /> */}
            <Button icon="pi pi-plus" className="p-button-success p-mr-2" rounded loading={loading} disabled={loading} onClick={handleAdd} tooltip='Add a new reception code'/>
        </span>
    </React.Fragment>
);
  

  


return (
    <Card className ="justify-content-md-center mx-5">
        <Container >
        <div className="card">
            <Toolbar 
                start={
                <Container className="flex align-content-center flex-wrap">
                    <Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className='flex'/> 
                    <h4 className='flex mt-2'>Reception Codes</h4> 
                </Container>}
                end={endContent}/>
            </div>
            <Messages ref={msgs} />
            <Toast ref={toastBC} position="top-center" />
            <div className='justify-content-md-center mt-3'>
                <DataTable 
                    // ref={dt} 
                    value={receptionCodes}
                    // globalFilter={globalFilter}
                    dataKey="id"
                    // selectionMode='single' selection={selectedReceptionCode} onSelectionChange={(e) => setSelectedReceptionCode(e.value)}
                    editMode='row'> 
                    <Column field="code" header="Code" sortable/>
                    <Column field="location.name" header="Location" sortable />
                    {/* <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column> */}
                </DataTable>
            </div>
        </Container>
        {/* <Dialog visible={displayDialog} style={{ width: '450px' }} header="HubRelay Details" modal className="p-fluid" footer={hubRelayDialogFooter} onHide={handleCancel}>
            <Toast ref={toast} />
            <div className="p-field">
                <label htmlFor="relay">Relay ID</label>

                <InputText id="relay" name="relay" value={newRelayId} onChange={(e) => setNewRelayId(e.target.value)} required autoFocus  />
                {submitted && !newRelayId && <small className="p-invalid">Relay ID is required.</small>}
            </div>
            <div className="p-field mt-3">
                <label htmlFor="hub">Hub ID</label>
                <InputText id="hub" name="hub" value={newHubId} onChange={(e) => setNewHubId(e.target.value)} required  />
                {submitted && !newHubId && <small className="p-invalid">Hub Id is required.</small>}
            </div>
            <div className="p-field mt-3">
                <p><label>Allowed</label></p>
                <InputSwitch id="allowed" name="allowed" checked={newAllowed} onChange={(e) => setNewAllowed(e.value)}/>
            </div>
        </Dialog>
        <Dialog visible={displayDialogDelete} style={{ width: '450px' }} header="Confirm" modal footer={deleteHubRelayDialogFooter} onHide={handleDeleteCancel}>
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                {hubRelay && <span>Are you sure you want to delete <b>{hubRelay.ajaxrelayid}</b>?</span>}
            </div>
        </Dialog> */}
    </Card>
);

}
export default ReceptionCodes;